<div class="row">
    <div [ngClass]="isAdd ? 'col-sm-6' : 'col-sm-10'">
        <kendo-grid #childCustomerGrid
                    [data]="gridData"
                    [pageSize]="gridState.take"
                    [skip]="gridState.skip"
                    [sort]="gridState.sort"
                    [filter]="gridState.filter"
                    [pageable]="true"
                    [sortable]="true"
                    [filterable]="true"
                    [resizable]="true"
                    [autoSize]="true"
                    (dataStateChange)="dataStateChange($event)">
            <kendo-grid-column title="Action">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <!--<button type="button" class="btn btn-sml btn-success m-1" title="Edit" tabindex="-1" (click)="edit(dataItem.customerID)"><i class="fas fa-pencil-alt"></i></button>-->
                    <button type="button" class="btn btn-sml btn-danger m-1" title="Delete" tabindex="-1" (click)="delete(dataItem.customerID)"><i class="fas fa-times"></i></button>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="name" title="Name">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <a target="_blank" [routerLink]="['/customer-detail', dataItem.customerCode]">
                        {{dataItem.name}}
                    </a>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="customerCode" title="Code"></kendo-grid-column>
            <kendo-grid-column field="address1" title="Address"></kendo-grid-column>
            <kendo-grid-column field="city.cityStateZip" title="City/ST Zip"></kendo-grid-column>
        </kendo-grid>
    </div>
    <div class="col-sm-1" *ngIf="!isAdd">
        <button class="btn btn-sml btn-primary" title="Add New" tabindex="-1" (click)="addNew()" *ngIf="!isAdd"><i class="fas fa-plus"></i></button>
    </div>

    <div class="col-sm-5" *ngIf="isAdd">
        <!-- Edit Child Customer form -->
        <customer-child-form [parentCustomerID]="parentCustomerID" (onRefresh)="cancelEdit()"></customer-child-form>
    </div>
</div>
